import {formatDateTime} from 'mc/lib/utils/commons';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import DataTable from '../datatable/DataTable';
import StavVolaniLabel from "./StavVolaniLabel";
import ButtonModal from "./ButtonModalOutput";

export default class LogTable extends PureComponent {

    static propTypes = {
        rows: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props);

        this.columns = [
            {
                name: "uzivatelLogin",
                label: "Uživatel",
            },
            {
                name: "sluzba",
                label: "Služba",
            },
            {
                name: "datumCasVolani",
                label: "Datum a čas volání",
                format: (v) => formatDateTime(v, {includeSeconds: true}),
            },
            {
                name: "stav",
                label: "Stav",
                component: StavVolaniLabel,
            },
            {
                name: "parametryVstup",
                label: "Vstupní parametry",
                component: ButtonModal,
            },
            {
                name: "parametryVystup",
                label: "Výstupní parametry",
                component: ButtonModal,
            },
            {
                name: "popisChyba",
                label: "Popis chyby",
                component: ButtonModal,
            }
        ];
    }

    render() {
        const {rows} = this.props;
        return <DataTable columns={this.columns}
                          rows={rows}
                          bodyProps={{className: "items-list"}}
                          bodyRowProps={{className: "card-block actions-hover"}}
                          striped
                          hover
                          bordered/>;
    }

}
